import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// Assets
import { openExactImageLightBox } from '../../actions/ImageLightBox';
import mediumNoImage from '/public/SiteImages/medium_no_image.png';
import largeNoImage from '/public/SiteImages/large_no_image.jpeg';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ListGridCoverPhoto.css'
import cx from 'classnames';

const ListGridCoverPhoto = (props) => {

	const dispatch = useDispatch();
	const [photo, setPhoto] = useState(null);
	const { coverPhoto, listPhotos, className, photoType, bgImage } = props;


	useEffect(() => {
		let activePhoto;
		if (listPhotos != undefined && listPhotos.length > 0) {
			activePhoto = listPhotos[0].name;
			if (coverPhoto != undefined && coverPhoto != null) {
				listPhotos.map((item) => {
					if (item.id === coverPhoto) {
						activePhoto = item.name;
					}
				})
			}
			setPhoto(activePhoto);
		}
	}, [coverPhoto, listPhotos])

	const renderImage = ({ imgIndex, imgSrc, className }) => {
		return (<a
			onClick={() => dispatch(openExactImageLightBox(imgIndex))}>
			<div className={className} style={{ backgroundImage: `url(${imgSrc})` }}>
				{props.children}
			</div>
		</a>)
	}

	let img0, img1, img2, img3, img4;
	if (listPhotos != undefined && listPhotos.length > 0) {
		img0 = listPhotos[0] && listPhotos[0].src;
		img1 = listPhotos[1] && listPhotos[1].src;
		img2 = listPhotos[2] && listPhotos[2].src;
		img3 = listPhotos[3] && listPhotos[3].src;
		img4 = listPhotos[4] && listPhotos[4].src;
	}

	let path = '', source;
	if (photo != null) {
		source = photo;
		if (photoType != undefined) {
			path = '/images/upload/x_medium_';
		}
	} else {
		if (photoType != undefined) {
			if (photoType === "xx_large") {
				source = largeNoImage;
			} else if (photoType === "x_medium") {
				source = mediumNoImage;
			}
		} else {
			source = mediumNoImage
		}
	}

	if (bgImage) {

		return (
			<div>
				{
					listPhotos && listPhotos.length == 1 && <div className={cx(s.leftBanner, 'rightTopBannerRTL')}>
						{renderImage({ imgIndex: 1, imgSrc: img0, className: cx(className, s.bgbanner) })}
					</div>
				}
				{
					listPhotos && listPhotos.length == 2 && <div className={cx(s.leftBanner, 'rightTopBannerRTL')}>
						<div className={s.gridTwo}>
							{renderImage({ imgIndex: 1, imgSrc: img0, className: cx(className, s.bgbanner, s.leftBorderRadius) })}
							{renderImage({ imgIndex: 2, imgSrc: img1, className: cx(className, s.bgbanner, s.rightBorderRadius) })}
						</div>
					</div>
				}

				{
					listPhotos && listPhotos.length == 3 && <div className={cx(s.leftBanner, 'rightTopBannerRTL')}>
						<div className={s.gridTwo}>
							{renderImage({ imgIndex: 1, imgSrc: img0, className: cx(className, s.bgbanner, s.leftBorderRadius) })}
							<div>
								{renderImage({ imgIndex: 2, imgSrc: img1, className: cx(className, s.bgbanner, s.bgBannerTwo, s.bannerBottom, s.rightBorderTopRadius) })}
								{renderImage({ imgIndex: 3, imgSrc: img2, className: cx(className, s.bgbanner, s.bgBannerTwo, s.rightBorderTopRadius) })}
							</div>
						</div>
					</div>
				}

				{
					listPhotos && listPhotos.length == 4 && <div className={cx(s.leftBanner, 'rightTopBannerRTL')}>
						<div className={s.gridTwo}>
							{renderImage({ imgIndex: 1, imgSrc: img0, className: cx(className, s.bgbanner) })}
							<div>
								{renderImage({ imgIndex: 2, imgSrc: img1, className: cx(className, s.bgbanner, s.bgBannerTwo, s.bannerBottom) })}
								<div className={s.gridTwo}>
									{renderImage({ imgIndex: 3, imgSrc: img2, className: cx(className, s.bgbanner, s.bgBannerTwo) })}
									{renderImage({ imgIndex: 4, imgSrc: img3, className: cx(className, s.bgbanner, s.bgBannerTwo) })}
								</div>
							</div>
						</div>
					</div>
				}

				{
					listPhotos && listPhotos.length >= 5 && <div className={cx(s.leftBanner, 'rightTopBannerRTL')}>
						<div className={s.gridTwo}>
							{renderImage({ imgIndex: 1, imgSrc: img0, className: cx(className, s.bgbanner) })}
							<div>
								<div className={s.gridTwo}>
									{renderImage({ imgIndex: 2, imgSrc: img1, className: cx(className, s.bgbanner, s.bgBannerTwo, s.bannerBottom) })}
									{renderImage({ imgIndex: 3, imgSrc: img2, className: cx(className, s.bgbanner, s.bgBannerTwo, s.bannerBottom) })}
								</div>
								<div className={s.gridTwo}>
									{renderImage({ imgIndex: 4, imgSrc: img3, className: cx(className, s.bgbanner, s.bgBannerTwo) })}
									{renderImage({ imgIndex: 5, imgSrc: img4, className: cx(className, s.bgbanner, s.bgBannerTwo) })}
								</div>
							</div>
						</div>
					</div>
				}
			</div>
		);
	} else {
		return (
			<img src={path + source} className={className} alt={'ListingCoverPhoto'} />
		);
	}
}

ListGridCoverPhoto.propTypes = {
	coverPhoto: PropTypes.number,
	listPhotos: PropTypes.array,
	className: PropTypes.string,
	bgImage: PropTypes.bool
};

ListGridCoverPhoto.defaultProps = {
	bgImage: false
}


export default withStyles(s)(ListGridCoverPhoto);

